import { TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";

interface DebouncedLabelFieldProps {
  value: string;
  onCommit: (value: string) => void;
  label: string;
  disabled?: boolean;
  sx?: object;
}

const DebouncedLabelField = ({ value, onCommit, label, disabled, sx }: DebouncedLabelFieldProps) => {
  const [localValue, setLocalValue] = useState(value);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (newValue: string) => {
    setLocalValue(newValue);

    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      onCommit(newValue);
    }, 400);
  };

  const handleBlur = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    onCommit(localValue);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <TextField
      size="small"
      label={label}
      value={localValue}
      disabled={disabled}
      onChange={(e) => handleChange(e.target.value)}
      onBlur={handleBlur}
      sx={sx}
    />
  );
};

export default DebouncedLabelField;